import customFetch from '../../utils/customFetch'
import { API_ENDPOINT } from '../../config'
import { RentControlResponseDto } from '../../@types/valuation-types'
import { getDefaultLogger } from '../../services/logger/logger'

export const getRentControl = async (city: string): Promise<boolean | null | undefined> => {
  const options = {
    method: 'GET',
    headers: {
      Accept: 'application/json; charset=utf-8',
    },
    credentials: 'include' as const,
  }

  try {
    const response = await customFetch(
      `${API_ENDPOINT}/anbieten/private-anbieter/inserieren/api/rent-control?city=${encodeURIComponent(city)}`,
      options
    )

    if (response.status === 200) {
      const apiResponse = (await response.json()) as RentControlResponseDto
      return apiResponse.rentControl
    }
    if (response.status === 404) {
      return null
    }

    getDefaultLogger().warn('Failed to load rent control from valuation API', response)
    return undefined
  } catch (error) {
    getDefaultLogger().warn('Failed to load rent control from valuation API', error)
    return undefined
  }
}
